import SectionButtonGroup from "../../../../components/Button/SectionButtonGroup"
//import InfoWatchlistText from "./InfoWatchlistText";
//import InfoSeqText from "./InfoSeqText";



export default function SectionGeneticsCvdButtonGroup() {

return(
<>      

<SectionButtonGroup

      button_1 = "IMPORTANT READ"
      button_2 = "CVD INFO"
      button_3 = "COUNSELING"
      
      title_dialog_1 = "Individual CVD Risks"
      content_dialog_1 = {""}
      
      title_dialog_2 = "Information CVD Risks"
      content_dialog_2 = {""}

      to = "/Doctor"

/>

</>
)}